<section
  class="columns-customize"
  [ngClass]="{ hidden: !active }"
  [class.active]="active"
  (keyup.escape)="hide()"
>
  <div class="top-items">
    <span class="filter-by-text">COLUMNS</span>
    <button type="reset" class="reset-button" (click)="reset()">RESET</button>
  </div>
  <div class="checkboxes">
    <div
      class="checkbox-row"
      *ngFor="let col of columns | keyvalue: $any(KeepOriginalOrder)"
    >
      <mat-checkbox
        class="checkbox"
        [checked]="col.value"
        [color]="'primary'"
        (change)="itemClicked(col.key)"
        >{{ SplitStringByCapitalLetter(col.key) }}</mat-checkbox
      >
    </div>
  </div>
</section>
